import React from 'react'
import { Box, Hint, Inscription } from '@common-fe/common-fe'

interface Props {
  button: React.ReactNode;
  hintText?: string;
  isTerminatedEmployer?: boolean;
}

export const ButtonHintForTerminatedEmployer: React.FC<Props> = ({
  button,
  hintText,
  isTerminatedEmployer = false,
}) => {
  return (
    <Hint
      hintAlign="left"
      hintWidth={220}
      hideHint={!isTerminatedEmployer}
      hintElement={button}
      marginContent="m"
    >
      <Box direction="row" justify="center" align="center">
        <Inscription textAlign="center">{hintText}</Inscription>
      </Box>
    </Hint>
  )
}
